<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'ReviewFilter',
  computed: {
    ...mapState({
      brands: state => state.review.filter.items,
      selectedBrands: state => state.review.filter.selectedBrands,
      selectedDomains: state => state.review.filter.selectedDomains,
      sites: state => state.review.filter.sites,
      selectedSites: state => state.review.filter.selectedSites,
      reviewsLoading: state => state.review.approval.loading,
      reviewsHasMore: state => state.review.approval.items.hasMore,
    }),
    ...mapGetters({
      availableDomains: 'review/availableDomains',
    }),
  },
  methods: {
    ...mapActions({
      fetchReviews: 'review/fetchReviews',
      fetchApprovalStatusOverview: 'review/fetchApprovalStatusOverview',
      fetchBrandsAndDomains: 'review/fetchBrandsAndDomains',
      updateSelectedBrands: 'review/updateSelectedBrands',
      updateSelectedDomains: 'review/updateSelectedDomains',
      removeBrand: 'review/removeBrand',
      removeDomain: 'review/removeDomain',
      fetchSites: 'review/fetchSites',
      updateSelectedSites: 'review/updateSelectedSites',
    }),
    search() {
      this.fetchReviews()
        .then(() => {
          this.fetchApprovalStatusOverview()
            .then(() => {
              this.$vuetify.goTo(0);
            });
        });
    },
  },
  created() {
    this.fetchBrandsAndDomains();
    this.fetchSites();
  },
};
</script>

<template>
  <v-card>
    <v-card-title>
      <v-layout>
        <v-flex xs10>
          <h2>{{ $t('review.filter.filterTitle') }}</h2>
        </v-flex>
        <v-flex xs1>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon color="blue" v-on="on">info</v-icon>
            </template>
            <span>{{ $t('review.filter.toolTip') }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-divider class="mx-3"/>
    <v-card-text>
      <v-layout wrap>
        <v-flex d-flex mb-3 xm12>
          <v-btn
            @click="search"
            :disabled="reviewsLoading"
            :loading="reviewsLoading"
            color="info"
            block
          >
            <span>{{ $t('review.filter.search') }}</span>
          </v-btn>
        </v-flex>
        <v-flex d-flex xs12>
          <v-select
            @change="updateSelectedBrands"
            :items="brands"
            :value="selectedBrands"
            :label="$t('review.filter.brands')"
            item-text="name"
            clearable
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                @input="removeBrand(index)"
                close
                small
              >
                <span class="chipText">{{ item.name }}</span>
              </v-chip>
            </template>
          </v-select>
        </v-flex>
        <v-flex d-flex xs12>
          <v-select
            @change="updateSelectedDomains"
            :items="availableDomains"
            :value="selectedDomains"
            :label="$t('review.filter.domains')"
            item-text="name"
            clearable
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                @input="removeDomain(index)"
                close
                small
              >
                <span class="chipText">{{ item.name }}</span>
              </v-chip>
            </template>
          </v-select>
        </v-flex>
        <v-flex d-flex xs12>
          <v-autocomplete
            @change="updateSelectedSites"
            :items="sites"
            :value="selectedSites"
            :label="$t('review.filter.sites')"
            item-text="name"
            item-value="id"
            clearable
            dense
            chips
            small-chips
            multiple
            deletable-chips
            flat
          >
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewFilter.vue